// 公告信息
import request from '@/utils/request'

export function queryAllNotificationType() {
    return request.post('/notification/queryAllNotificationType')
}

export function queryNotificationByConditions(param) {
    return request.post('/notification/queryNotificationByConditions', param)
}